import React from 'react';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';

import { Authenticator, useAuthenticator } from '@aws-amplify/ui-react';
import { Box, Grid, Link, Typography } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { FacilityState } from '@atom/FacilityState';

import PageBaseNoSignIn from '../PageBaseNoSignIn';
import './LoginPage.css';

/* コンポーネント設定 */
const components = {
  SignIn: {
    Header() {
      return (
        <Box>
          <Typography variant="h5" sx={{ p: '5% 0 0 0' }}>
            ログイン
          </Typography>
        </Box>
      );
    }
  },
  ForceNewPassword: {
    Header() {
      return (
        <Box>
          <Typography variant="h5" sx={{ p: '0 0 5% 0' }}>
            初回パスワード変更
          </Typography>
          <Typography variant="body2" sx={{ p: 1 }}>
            新しいパスワードを入力して「変更する」ボタンを押してください。
          </Typography>
        </Box>
      );
    }
  },
  ForgotPassword: {
    Header() {
      return (
        <Box>
          <Typography variant="h5" sx={{ p: '0 0 5% 0' }}>
            パスワードを忘れた方
          </Typography>
          <Typography variant="body2" sx={{ p: 1 }}>
            団体IDに登録されたメールアドレスを入力してください。
            <br />
            メールアドレスの登録がない場合は、施設までご来館いただくか、お電話でご連絡ください。
          </Typography>
        </Box>
      );
    }
  },
  ConfirmResetPassword: {
    Header() {
      return (
        <Box>
          <Typography variant="h5" sx={{ p: '0 0 5% 0' }}>
            パスワード変更
          </Typography>
          <Typography variant="body2" sx={{ p: 1 }}>
            ご指定のメールアドレスにパスワード変更のためのコードを送付しました。
            <br />
            <br />
            メールに送信されたコードと新しいパスワードを入力して「変更する」ボタンを押してください。
            <br />
            <br />
            <Link href="https://aomori-arena.jp/application_form/" target="_blank" rel="noopener noreferrer">
              メールが届かない場合はこちら
            </Link>
          </Typography>
        </Box>
      );
    }
  }
};

/* ログインのフィールド設定 */
const formFields = {
  signIn: {
    username: {
      placeholder: '団体IDを入力',
      isRequired: true,
      label: '団体ID'
    }
  },
  forceNewPassword: {
    password: {
      label: '新しいパスワード',
      isRequired: true,
      placeholder: 'パスワードを入力'
    },
    confirm_password: {
      label: '新しいパスワード（確認）',
      isRequired: true,
      placeholder: '確認のためもう一度入力をお願いします'
    }
  },
  forgotPassword: {
    username: {
      placeholder: 'メールアドレスを入力',
      isRequired: true,
      label: 'メールアドレス'
    }
  },
  confirmResetPassword: {
    confirmation_code: {
      placeholder: 'コードを入力',
      label: 'コード *',
      isRequired: true
    },
    password: {
      label: '新しいパスワード',
      isRequired: true,
      placeholder: 'パスワードを入力'
    },
    confirm_password: {
      label: '新しいパスワード（確認）',
      isRequired: true,
      placeholder: '確認のためもう一度入力をお願いします'
    }
  }
};

const LoginPage = () => {
  const location = useLocation();
  const [ searchParams ] = useSearchParams();
  const facility = useRecoilValue(FacilityState);
  const { facilityId } = facility;
  const facilityIdParam = searchParams.get('facilityId') ?? facilityId;
  
  let nextPathName = `/c001/arealist?facilityId=${facilityIdParam}`;
  if (location.state && 'nextPathName' in location.state){
    nextPathName = location.state.nextPathName;
  }

  const { authStatus } = useAuthenticator((context) => [context.authStatus]);

  return authStatus === 'authenticated' ? (
    <Navigate to={nextPathName} replace />
  ) : (
    <PageBaseNoSignIn>
      <Box width="100%">
        <Grid container direction="row" justifyContent="center" alignItems="center" sx={{ p: '0 10%' }}>
          <Authenticator hideSignUp components={components} formFields={formFields} />
          <Link href="/#/c007/register">新規登録はこちら</Link>
        </Grid>
      </Box>
    </PageBaseNoSignIn>
  );
};

export default LoginPage;
